import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface AdminState {
  editingMtmSettingsId: string | null;
  showMtmSettingsModal: boolean;
  editingMomentmSettingsId: string | null;
  showMomentmSettingsModal: boolean;
  backfillTripsProviderId: string | null;
  showBackfillTripsModal: boolean;
  showKinetikSettingsModal: boolean;
  showModivcareSettingsModal: boolean;
  showAliviSettingsModal: boolean;
  showClearviewTransportPayerModal: boolean;
  showClearviewTransportProviderModal: boolean;
}

export const initialState: AdminState = {
  editingMtmSettingsId: null,
  showMtmSettingsModal: false,
  editingMomentmSettingsId: null,
  showMomentmSettingsModal: false,
  backfillTripsProviderId: null,
  showBackfillTripsModal: false,
  showKinetikSettingsModal: false,
  showModivcareSettingsModal: false,
  showAliviSettingsModal: false,
  showClearviewTransportPayerModal: false,
  showClearviewTransportProviderModal: false,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setEditingMtmSettingsId: (state, action: PayloadAction<string | null>) => {
      state.editingMtmSettingsId = action.payload;
    },
    setShowMtmSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.showMtmSettingsModal = action.payload;
    },
    setEditingMomentmSettingsId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.editingMomentmSettingsId = action.payload;
    },
    setShowMomentmSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.showMomentmSettingsModal = action.payload;
    },
    setBackfillTripsProviderId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.backfillTripsProviderId = action.payload;
    },
    setShowBackfillTripsModal: (state, action: PayloadAction<boolean>) => {
      state.showBackfillTripsModal = action.payload;
    },
    setShowKinetikSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.showKinetikSettingsModal = action.payload;
    },
    setShowModivcareSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.showModivcareSettingsModal = action.payload;
    },
    setShowAliviSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.showAliviSettingsModal = action.payload;
    },
    setShowClearviewTransportPayerModal: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showClearviewTransportPayerModal = action.payload;
    },
    setShowClearviewTransportProviderModal: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showClearviewTransportProviderModal = action.payload;
    },
  },
});

export const adminActions = adminSlice.actions;
